import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaCode } from "react-icons/fa";
import "../assets/css/home.css";

const services = [
  { title: "Exhibition Stalls", desc: "At New Elite International LLC, we are redefining the world of advertising and visual communication with innovation, creativity, and precision." },
  { title: "Designing", desc: "At New Elite International LLC, we are redefining the world of advertising and visual communication with innovation, creativity, and precision." },
  { title: "Flange", desc: "At New Elite International LLC, we are redefining the world of advertising and visual communication with innovation, creativity, and precision." },
  { title: "Sticker, Pamphlet", desc: "At New Elite International LLC, we are redefining the world of advertising and visual communication with innovation, creativity, and precision." },
  { title: "Digital Boards", desc: "At New Elite International LLC, we are redefining the world of advertising and visual communication with innovation, creativity, and precision." },
  { title: "Flex Printing", desc: "At New Elite International LLC, we are redefining the world of advertising and visual communication with innovation, creativity, and precision." },
  { title: "Event Branding", desc: "At New Elite International LLC, we are redefining the world of advertising and visual communication with innovation, creativity, and precision." },
  { title: "LED Display", desc: "At New Elite International LLC, we are redefining the world of advertising and visual communication with innovation, creativity, and precision." },
  { title: "Posters", desc: "At New Elite International LLC, we are redefining the world of advertising and visual communication with innovation, creativity, and precision." }
];

const ServicesCarousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 3, 
    arrows: false,
    centerMode: true,
    centerPadding: "80px",
    customPaging: () => <div className="custom-dot" />, 
    dotsClass: "slick-dots custom-dots",
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 2, slidesToScroll: 2, centerPadding: "50px" } },
      { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1, centerPadding: "30px" } }
    ]
  };

  return (
    <section className="bg-carousalsection">
      <div className="container-fluid mb-5 pt-4">
        <h2 className="text-center fw-bold mb-4">Services we offer</h2>
        <Slider {...settings}>
          {services.map((service, index) => (
            <div key={index} className="p-3">
              <div className="card border-0 shadow-sm h-100 text-center p-4">
                <div className="mb-3">
                  <FaCode size={30} color="#6c63ff" />
                </div>
                <h5 className="fw-bold">{service.title}</h5>
                <p className="text-muted">{service.desc}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default ServicesCarousel;
